<template>
  <ViewSubChapter v-if="childrenCount === 1" :category="category.children[0]" />
  <div v-else class="groups">
    <ChapterGroup
      v-for="group in groups"
      :key="group.title"
      :items="group.items"
      :title="group.title"
      :opened="false"
    />
  </div>
</template>
<script lang="ts" setup>
const { categoryManager } = inject(INJECT_CATEGORY_PAGE);

const { category } = categoryManager;

const childrenCount = computed(() => category.value?.children?.length || 0);

const groups = computed(() => {
  const mItems: Map<string, { title: string; items: CategorySchema[] }> =
    new Map();
  category.value.children.forEach((item) => {
    const groupLabel = item.groupLabel || '';
    if (!mItems.has(groupLabel)) {
      mItems.set(groupLabel, {
        title: groupLabel,
        items: [],
      });
    }
    mItems.get(groupLabel).items.push(item);
  });
  let lGroups = Array.from(mItems.values());
  lGroups.forEach((group) => {
    group.items = group.items.filter((item) => {
      return (
        item?.posts?.length || item?.exercises?.length || item?.children?.length
      );
    });
  });
  lGroups = lGroups.filter((group) => group.items.length > 0);
  return lGroups;
});
</script>
<style lang="scss" scoped>
.groups {
  display: flex;
  flex-direction: column;
  gap: var(--gap_xl);
}
</style>
